import { format } from "date-fns";
import type { DateRange } from "react-day-picker";

export function formattedTimeRange(range: DateRange) {
  return `${format(range.from!, "MMMM d, yyyy")} - ${format(
    range.to!,
    "MMMM d, yyyy"
  )}`;
}
